import { render, staticRenderFns } from "./EditClinicalNotesDialog.vue?vue&type=template&id=73b3bdcd&scoped=true"
import script from "./EditClinicalNotesDialog.vue?vue&type=script&lang=js"
export * from "./EditClinicalNotesDialog.vue?vue&type=script&lang=js"
import style0 from "./EditClinicalNotesDialog.vue?vue&type=style&index=0&id=73b3bdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3bdcd",
  null
  
)

export default component.exports